import TicketCard from "./TicketCard"

export default  TicketCard;
